// Synchronous polyfills for Node.js globals in browser environment
import { Buffer as BufferPolyfill } from 'buffer';

if (typeof global === 'undefined') {
  (window as any).global = window;
}

if (typeof process === 'undefined') {
  (window as any).process = { env: {} };
}

if (typeof (window as any).Buffer === 'undefined') {
  (window as any).Buffer = BufferPolyfill;
}

// Ensure crypto is available
if (typeof crypto === 'undefined') {
  (window as any).crypto = (window as any).crypto || {};
} 